import React from 'react';
import classNames from 'classnames';
import { SendIcon } from 'icons';
import Image from 'next/image';
import Link from 'next/link';

import { ISocialMedia } from 'modules/pro';

interface IProps {
  item: ISocialMedia;
}

const Card: React.FC<IProps> = ({ item }) => (
  <Link target="_blank" href={item.url}>
    <div
      className={classNames(
        item.bgColor,
        'h-51 group relative flex flex-col justify-between overflow-hidden rounded-2xl p-4'
      )}
    >
      <p className="text-lg font-semibold text-gray-800">{item.name.toUpperCase()}</p>

      <div className="flex items-center justify-between">
        <div className="absolute bottom-2 flex size-11 items-center justify-center rounded-full bg-white opacity-0 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:opacity-100">
          <SendIcon />
        </div>
        <div className="w-33.5 md:w-41 absolute -bottom-4 right-0 aspect-[1.18]">
          <Image
            fill
            src={item.logo}
            alt={item.name}
            className="group-hover:scale-115 object-contain transition-transform duration-500"
          />
        </div>
      </div>
    </div>
  </Link>
);

export default Card;
